import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { retry, timeout } from 'rxjs/operators';
import { ApiBuilder, QueryStringParameters } from '@app/core/helpers';
import { Constants } from '@app/core/config';
import { PortalUserDto } from '../models/portalUserDto';
import { PortalStorageService } from '../../../services/storage/portal-storage.service';
import { AuthService } from '../../auth/services/auth.service';
import { ResultDto } from '../../../models/resultDto';
import { UpdatePortalUserPasswordCommand } from '../requests/updatePortalUserPasswordCommand';
import { UpdatePortalUserCommand } from '../requests/updatePortalUserCommand';
import { SendPortalContactEmailCommand } from '../requests/sendPortalContactEmailCommand';

@Injectable({
    providedIn: 'root',
})
export class AdminService {
    public portalUser: PortalUserDto;

    constructor(private http: HttpClient, private storageService: PortalStorageService, private authService: AuthService) {}

    getPortalUser(portalUserId: number): Observable<PortalUserDto> {
        const endpoint = ApiBuilder.createUrl(`${Constants.API_PORTAL_USER}/${portalUserId}`);
        return this.http.get<PortalUserDto>(endpoint).pipe(retry(1));
    }

    async getPortalUserAsync(portalUserId: number): Promise<PortalUserDto> {
        const endpoint = ApiBuilder.createUrl(`${Constants.API_PORTAL_USER}/${portalUserId}`);
        return await this.http.get<PortalUserDto>(endpoint).pipe(timeout(Constants.TIMER_SEC_THIRTY)).toPromise();
    }

    async getPortalUserLoggedinAsync(): Promise<void> {
        this.portalUser = this.storageService.getUser();
        if (this.portalUser === null) {
            let portalUserId = 0;
            if (this.authService.tokenValue !== null) {
                portalUserId = this.authService.tokenValue.userId;
                this.portalUser = await this.getPortalUserAsync(portalUserId);
                this.storageService.saveUser(this.portalUser);
            }
        } else if (this.portalUser != null && this.portalUser.portalUserId != this.authService.tokenValue.userId) {
            this.portalUser = await this.getPortalUserAsync(this.authService.tokenValue.userId);
            this.storageService.saveUser(this.portalUser);
        } else {
            this.portalUser = this.storageService.getUser();
        }
    }

    async updatePortalUserPasswordAsync(request: UpdatePortalUserPasswordCommand): Promise<ResultDto> {
        const endpoint = ApiBuilder.createUrl(`${Constants.API_PORTAL_USER_PASSWORD_UPDATE}`);
        return await this.http.post<ResultDto>(endpoint, JSON.stringify(request)).pipe(timeout(Constants.TIMER_SEC_THIRTY)).toPromise();
    }

    async sendContactEmailAsync(request: SendPortalContactEmailCommand): Promise<ResultDto> {
        const endpoint = ApiBuilder.createUrl(`${Constants.API_PORTAL_CONTACT}`);
        return await this.http.post<ResultDto>(endpoint, JSON.stringify(request)).pipe(timeout(Constants.TIMER_SEC_THIRTY)).toPromise();
    }

    async updatePortalUserAsync(request: UpdatePortalUserCommand): Promise<ResultDto> {
        const endpoint = ApiBuilder.createUrl(`${Constants.API_PORTAL_USER_UPDATE}`);
        return await this.http.post<ResultDto>(endpoint, JSON.stringify(request)).pipe(timeout(Constants.TIMER_SEC_THIRTY)).toPromise();
    }
}
